import * as React from 'react';
import * as main from "../../styles/main.module.scss";
import * as screen1 from "./style.module.scss";
import { HeaderLogoAndTel } from "../../../../HeaderLogoAndTel";

export const Screen1 = ({ accessLimited }) => {
  return (
    <header className={screen1.screen1}>
      <div className="container">
        <HeaderLogoAndTel phoneHide={true} logoCenter={true} />
        <h1 className={screen1.title}>
          Глобус на&nbsp;пальце
        </h1>
        <p className={screen1.subtitle}>
          Увлекательный онлайн-курс для&nbsp;тех, <br/>
          кто хочет знать все&nbsp;страны в&nbsp;мире и&nbsp;их&nbsp;расположение на&nbsp;карте
        </p>
        <div className={main.btnBlock}>
          <a className={main.mainBtn} href="#cost">
            Хочу на курс
          </a>
        </div>
        { accessLimited && <p style={{ margin: "30px 0 0", textAlign: "center" }}>Бесплатный доступ действителен в&nbsp;течение 7&nbsp;дней</p> }
      </div>
    </header>
  );
};
